export default "__VITE_ASSET__xaqIAGPO__"